import { authenticatedFetch } from "../utils/api";
import { API_HOST } from "../utils/constants";

const blockingBaseUrl = `${API_HOST}/api/episode-blocking`;

export const fetchEpisodeBlocking = (projectId, episodeId) => (
  authenticatedFetch(`${blockingBaseUrl}?projectId=${projectId}&episodeId=${episodeId}`)
);

export const saveEpisodeBlockingPlan = (payload) => (
  authenticatedFetch(`${blockingBaseUrl}/plan`, {
    method: payload?.id ? "PUT" : "POST",
    body: JSON.stringify(payload),
  })
);

export const applyEpisodeBlockingPlan = (payload) => (
  authenticatedFetch(`${blockingBaseUrl}/apply`, {
    method: "POST",
    body: JSON.stringify(payload),
  })
);

export const unassignEpisodeBlockingPlan = (payload) => (
  authenticatedFetch(`${blockingBaseUrl}/unassign`, {
    method: "POST",
    body: JSON.stringify(payload),
  })
);

export const deleteEpisodeBlockingPlan = (id, projectId, episodeId) => (
  authenticatedFetch(`${blockingBaseUrl}/plan?id=${id}&projectId=${projectId}&episodeId=${episodeId}`, {
    method: "DELETE",
  })
);
